import React from 'react'

const Contact = () => {

  return (
    <section id="contact">
      <h1>GET IN TOUCH</h1>
      <ul>
        <li className="contact-method">
          <img src="https://img.icons8.com/external-kiranshastry-gradient-kiranshastry/64/000000/external-email-interface-kiranshastry-gradient-kiranshastry.png"/>
          <a href="mailto:liewvyl@gmail.com"> liewvyl@gmail.com</a>
        </li>
        <li className="contact-method">
          <img src="https://img.icons8.com/nolan/256/linkedin.png"/>
          <a href="https://www.linkedin.com/in/liewvictor/" rel="noopener noreferrer" target="_blank"> LinkedIn</a>
        </li>
        <li className="contact-method">
          <img src="https://img.icons8.com/nolan/256/github.png"/>
          <a href="https://github.com/luckymouse11" rel="noopener noreferrer" target="_blank"> GitHub</a>
        </li>
      </ul>
    </section>
  )

}

export default Contact